/* Copyright (c) 2020-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useGetResourceGroupQuery } from "~/generated/graphql";

type Props = {
  resourceGroupId: string;
  skip?: boolean;
};

export function useGetResourceGroup({ resourceGroupId, skip = false }: Props) {
  const { data, loading, error } = useGetResourceGroupQuery({
    variables: { resourceGroupId },
    skip,
  });

  return { resourceGroup: data?.group ?? undefined, loading, error } as const;
}
